import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import store from "../store";

Vue.use(VueRouter);
/*
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      pageTitle: "Home",
      requiresAuth: true
    }
  },
  */

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Dashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "About" */ "../views/About.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/locations/create",
    name: "LocationCreate",
    component: () =>
      import(/* webpackChunkName: "Location" */ "../views/Location.vue"),
    meta: {
      action: "create",
      requiresAuth: true,
    },
  },
  {
    path: "/locations/:id",
    name: "Location",
    component: () =>
      import(/* webpackChunkName: "Location" */ "../views/Location.vue"),
    meta: {
      action: "update",
      requiresAuth: true,
    },
    props: castRouteParams,
  },
  {
    path: "/locations/:id/marketing",
    name: "Marketing",
    component: () =>
      import(/* webpackChunkName: "Marketing" */ "../views/Marketing.vue"),
    meta: {
      requiresAuth: true,
    },
    props: castRouteParams,
    children: [
      {
        path: "email",
        name: "MarketingEmail",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "MarketingEmail" */ "../views/MarketingEmail.vue"
          ),
      },
      {
        path: "feedback",
        name: "MarketingFeedback",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "MarketingFeedback" */ "../views/MarketingFeedback.vue"
          ),
      },
      {
        path: "privacy",
        name: "MarketingPrivacyPolicy",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "MarketingPrivacyPolicy" */ "../views/MarketingPrivacyPolicy.vue"
          ),
      },
    ],
  },
  {
    path: "/locations/:id/categories",
    name: "Categories",
    component: () =>
      import(/* webpackChunkName: "Categories" */ "../views/Categories.vue"),
    meta: {
      requiresAuth: true,
    },
    props: castRouteParams,
  },
  {
    path: "/locations/:id/categories/create",
    name: "CategoryCreate",
    component: () =>
      import(/* webpackChunkName: "Category" */ "../views/Category.vue"),
    meta: {
      action: "create",
      requiresAuth: true,
    },
    props: castRouteParams,
  },
  {
    path: "/locations/:id/categories/:idcategory",
    name: "Category",
    component: () =>
      import(/* webpackChunkName: "Category" */ "../views/Category.vue"),
    meta: {
      action: "update",
      requiresAuth: true,
    },
    props: castRoute2Params,
  },
  {
    path: "/locations/:id/dishes",
    name: "Dishes",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "Dishes" */ "../views/Dishes.vue"),
    props: castRouteParams,
  },
  {
    path: "/locations/:id/dishes/create/:catid?",
    name: "DishCreate",
    component: () => import(/* webpackChunkName: "Dish" */ "../views/Dish.vue"),
    meta: {
      action: "create",
      requiresAuth: true,
    },
    props: castRouteParams,
  },
  {
    path: "/locations/:id/dishes/:iddish",
    name: "Dish",
    component: () => import(/* webpackChunkName: "Dish" */ "../views/Dish.vue"),
    meta: {
      action: "update",
    },
    props: castRoutetestParams,
  },
  {
    path: "/locations/:id/menus",
    name: "Menus",
    component: () =>
      import(/* webpackChunkName: "Menus" */ "../views/Menus.vue"),
    meta: {
      requiresAuth: true,
    },
    props: castRouteParams,
  },
  {
    path: "/locations/:id/orders",
    name: "Orders",
    component: () =>
      import(/* webpackChunkName: "Orders" */ "../views/Orders.vue"),
    meta: {
      requiresAuth: true,
    },
    props: castRouteParams,
    children: [
      {
        path: "history",
        name: "OrdersHistory",
        props: {
          selectedStatus: "waiting",
          showStatus: false,
          showType: true,
          showOrderNumber: true,
          typesToInclude: [
            "domicilio",
            "asporto",
            "tavolo",
            "umbrella",
            "roomservice",
          ],
          avaibleOrderBy: [
            "order_date|desc",
            "order_date|asc",
            "created_at|desc",
            "created_at|asc",
          ],
          defaultOrderBy: "created_at|asc",
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
      {
        path: "delivery",
        name: "OrdersHistoryDelivery",
        props: {
          showStatus: true,
          statusToInclude: ["approved", "completed", "in-progress", "rejected"],
          showType: false,
          showOrderNumber: true,
          selectedType: "domicilio",
          initDate: true,
          orderDropDownType: "type2",
          avaibleOrderBy: [
            "order_date|desc",
            "order_date|asc",
            "created_at|desc",
            "created_at|asc",
          ],
          defaultOrderBy: "order_date|asc",
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
      {
        path: "takeaway",
        name: "OrdersHistoryTakeAway",
        props: {
          showStatus: true,
          statusToInclude: ["approved", "completed", "in-progress", "rejected"],
          showType: false,
          showOrderNumber: true,
          selectedType: "asporto",
          initDate: true,
          orderDropDownType: "type2",
          avaibleOrderBy: [
            "order_date|desc",
            "order_date|asc",
            "created_at|desc",
            "created_at|asc",
          ],
          defaultOrderBy: "order_date|asc",
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
      {
        path: "table",
        name: "OrdersHistoryTable",
        props: {
          showStatus: true,
          statusToInclude: ["approved", "completed", "in-progress", "rejected"],
          showType: false,
          showOrderNumber: true,
          selectedType: "tavolo",
          initDate: true,
          orderDropDownType: "type2",
          avaibleOrderBy: ["created_at|desc", "created_at|asc"],
          defaultOrderBy: "created_at|asc",
          showTable: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
      {
        path: "umbrella",
        name: "OrdersHistoryUmbrella",
        props: {
          showStatus: true,
          statusToInclude: ["approved", "completed", "in-progress", "rejected"],
          showType: false,
          showOrderNumber: true,
          selectedType: "umbrella",
          initDate: true,
          orderDropDownType: "type2",
          avaibleOrderBy: ["created_at|desc", "created_at|asc"],
          defaultOrderBy: "created_at|asc",
          showTable: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
      {
        path: "hotel",
        name: "OrdersHistoryHotel",
        props: {
          showStatus: false,
          statusToInclude: ["waiting"],
          showType: false,
          showOrderNumber: false,
          selectedType: "tavolo-hotel",
          initDate: true,
          orderDropDownType: "type3",
          avaibleOrderBy: ["room|desc", "room|asc"],
          defaultOrderBy: "room|asc",
          showTable: false,
          showRoom: true,
          showMenuTypes: true,
          menuTypesToInclude: ["breakfast", "lunch", "dinner"],
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
      {
        path: "roomservice",
        name: "OrdersHistoryRoomService",
        props: {
          showStatus: true,
          statusToInclude: ["approved", "completed", "in-progress", "rejected"],
          showType: false,
          showOrderNumber: true,
          selectedType: "roomservice",
          initDate: true,
          orderDropDownType: "type2",
          avaibleOrderBy: ["created_at|desc", "created_at|asc"],
          defaultOrderBy: "created_at|asc",
          showTable: false,
          showRoom: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "OrdersHistory" */ "../views/OrdersHistory.vue"
          ),
      },
    ],
  },
  {
    path: "/locations/:id/menus/create",
    name: "MenuCreate",
    component: () => import(/* webpackChunkName: "Menu" */ "../views/Menu.vue"),
    meta: {
      action: "create",
      requiresAuth: true,
    },
    props: castRouteParams,
  },
  {
    path: "/locations/:id/menus/:idmenu",
    name: "Menu",
    component: () => import(/* webpackChunkName: "Menu" */ "../views/Menu.vue"),
    meta: {
      action: "update",
      requiresAuth: true,
    },
    props: castRouteMenuParams,
  },
  {
    path: "/locations/:id/menus/:idmenu/compose",
    name: "MenuCompose",
    component: () =>
      import(/* webpackChunkName: "MenuCompose" */ "../views/MenuCompose.vue"),
    meta: {
      requiresAuth: true,
    },
    props: castRouteMenuParams,
  },
  {
    path: "/locations/:id/orderssettings",
    name: "OrdersSettings",
    component: () =>
      import(
        /* webpackChunkName: "OrdersSettings" */ "../views/OrdersSettings.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    props: castRouteParams,
    children: [
      {
        path: "delivery",
        name: "OrdersSettingsDelivery",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "OrdersSettingsDelivery" */ "../views/OrdersSettingsDelivery.vue"
          ),
      },
      {
        path: "takeaway",
        name: "OrdersSettingsTakeAway",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "OrdersSettingsTakeAway" */ "../views/OrdersSettingsTakeAway.vue"
          ),
      },
      {
        path: "table",
        name: "OrdersSettingsTable",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "OrdersSettingsTable" */ "../views/OrdersSettingsTable.vue"
          ),
      },
      {
        path: "umbrella",
        name: "OrdersSettingsUmbrella",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "OrdersSettingsUmbrella" */ "../views/OrdersSettingsUmbrella.vue"
          ),
      },
      {
        path: "roomservice",
        name: "OrdersSettingsRoomService",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "OrdersSettingsRoomService" */ "../views/OrdersSettingsRoomService.vue"
          ),
      },
      {
        path: "hotel",
        name: "OrdersSettingsHotel",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "OrdersSettingsHotel" */ "../views/OrdersSettingsHotel.vue"
          ),
      },
    ],
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () =>
      import(
        /* webpackChunkName: "PageNotFound" */ "../views/PageNotFound.vue"
      ),
    meta: {
      layout: "blank",
    },
  },
];

function castRouteParams(route) {
  return {
    id: Number(route.params.id),
    catid:
      route.params.catid == undefined ? undefined : Number(route.params.catid),
  };
}

function castRoute2Params(route) {
  return {
    id: Number(route.params.id),
    idcategory: Number(route.params.idcategory),
  };
}

function castRoutetestParams(route) {
  return {
    id: Number(route.params.id),
    iddish: Number(route.params.iddish),
  };
}

function castRouteMenuParams(route) {
  return {
    id: Number(route.params.id),
    idmenu: Number(route.params.idmenu),
  };
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "router-link-active",
  linkExactActiveClass:
    "router-link-exact-active bg-indigo-100 text-indigo-700 ",
});

/*
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log("-->"+store.getters.authenticated);
    if (store.getters.authenticated === true) {
      next()
      return
    }
    next('/login')
  }
  next()
  */

router.beforeEach((to, from, next) => {
  //console.log(store.getters.authenticated);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.authenticated == "true") {
      //console.log(store.getters.authenticated + "ssssssss");
      next();
      return;
    }
    //console.log("---"+to, from);
    //console.log(to, from);
    next("/login");
    //next();
    //next();
  } else {
    next();
  }
});

export default router;
